import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Header from './components/Header';
import Home from './pages/Home';
import './pages/mainstyle/Home.css';
import './components/style/Header.css';
import Footer from './components/Footer';
import './components/style/Footer.css';
import ServiceNowMigration from "./pages/services/ServiceNowMigration";
import SalesforceSolutions from './pages/services/SalesforceSolutions';
import InformaticaCloud from "./pages/services/Informaticacloud";
import './pages/mainstyle/Services.css';
import './components/style/Preloader.css';
import logo from './components/images/OGNIFYAR (1).png'
import Contact from './pages/Contact';
import './pages/mainstyle/Contact.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import About from './pages/About';
import "./pages/mainstyle/About.css"
import Careers from './pages/Careers'
import "./pages/mainstyle/Careers.css";

const Preloader = ({ onComplete }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      onComplete();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    loading && (
      <div className="preloader">
        <div className="preloader-logo">
          <h1><img src={logo} alt="Cognifyar Technologies" /></h1>
        </div>
        <div className="preloader-spinner"></div>
      </div>
    )
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenisRef = useRef();

  useEffect(() => {
    // Reset scroll position when pathname changes
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      // Fallback if Lenis isn't available
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

function App() {
  const lenisRef = useRef();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      smooth: true,
    });

    lenisRef.current = lenis;

    const scrollFn = (time) => {
      lenis.raf(time);
      requestAnimationFrame(scrollFn);
    };

    requestAnimationFrame(scrollFn);
    return () => {
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const [isPreloaderDone, setIsPreloaderDone] = useState(false);

  const handlePreloaderComplete = () => {
    setIsPreloaderDone(true);
  };

  return (
    <>
      {!isPreloaderDone && <Preloader onComplete={handlePreloaderComplete} />}
      {isPreloaderDone && (
        <Router basename="/">
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />}/>
            <Route path="/services/servicenow-migration" element={<ServiceNowMigration />} />
            <Route path="/services/salesforce-solutions" element={<SalesforceSolutions/>} />
            <Route path="/services/informatica-cloud" element={<InformaticaCloud />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </Router>
      )}
    </>
  );
}

export default App;